// extracted by mini-css-extract-plugin
export default {"layout":"SharedLayout_layout__3kTxB","main":"SharedLayout_main__VUmTe"};